import {
  byClass,
  getCurrentPage,
  isMobile,
  getBrowser,
  setStyle,
  calcPageScrollPercent
} from './utils'

let videoEl = byClass('craft-inspiration-video')
let isPlaying = false

function playVideo () {
  if (isPlaying) return
  videoEl.play()
  isPlaying = true
}

function pauseVideo () {
  if (!isPlaying) return
  videoEl.pause()
  isPlaying = false
}

/**
 * Craft, Inspiration video zoom in & zoom out
 * 当视频不在屏幕中时，自动暂停
 * 当视频在屏幕中时，自动播放
 */
function animateCraftVideo () {
  if (getCurrentPage() === 'craft-inspiration' || getCurrentPage() === 'your') {
    if (isMobile()) {
      playVideo()
      videoEl.setAttribute('autoplay', 'autoplay')
      videoEl.setAttribute('controls', 'controls')
      return
    }
    playVideo()
    if (getBrowser() === 'ie' || getBrowser() === 'edge' || getBrowser() === 'safari') return
    const percent = calcPageScrollPercent('craft-inspiration')
    animateTitle(percent)
    animateWhiteCurtain(percent)
    animateDescription(percent)
  } else {
    pauseVideo()
    videoEl.removeAttribute('autoplay')
    videoEl.removeAttribute('controls')
    return
  }
}

/**
 * 逐渐放大的标题文字
 * [0,   0.2): width 700px
 * [0.2, 0.8): width 700px -> 极大
 * [0.8, 1  ): hidden
 *
 * height = width * 72 / 700
 */
function animateTitle (percent) {
  const titleEl = byClass('craft-inspiration-title-img')
  if (percent < 0.2) {
    setStyle(titleEl, {
      width: '700px',
      height: `72px`,
      opacity: 1
    })
  } else if (percent < 0.8) {
    const width = Math.pow(percent - 0.2, 3) * 2800000 + 700
    const height = width * 72 / 700
    setStyle(titleEl, {
      width: `${width}px`,
      height: `${height}px`,
      opacity: 1
    })
  } else {
    setStyle(titleEl, {
      opacity: 0
    })
  }
}

/**
 * 透明白色帷幕
 */
function animateWhiteCurtain (percent) {
  const whiteCurtainEl = byClass('craft-inspiration-white')
  if (percent < 0.25) {
    setStyle(whiteCurtainEl, {
      opacity: 1
    })
  } else {
    setStyle(whiteCurtainEl, {
      opacity: 0
    })
  }
}

/**
 * 透明描述文本
 */
function animateDescription (percent) {
  const descriptionEl = byClass('craft-inspiration-description')
  if (percent < 0.3) {
    setStyle(descriptionEl, {
      opacity: 1
    })
  } else {
    setStyle(descriptionEl, {
      opacity: 0
    })
  }
}

export {
  animateCraftVideo
}
